import GYSelect from "./gyselect.js";

$(function () {
    ////////// STORE RFQ TYRE DROPDOWN  //////////
    const $category_dropdown = $("#rfq-tyres-cont");
    $category_dropdown.on("click", function (e) {
        if ($(e.target).closest(".tyre-info-group .autocomplete-items").length) return;

        if ($(".tyre-info-group .autocomplete-items").is(":visible")) {
            $(".tyre-info-group .autocomplete-items").stop().slideUp(200);
            //$(".page-number").attr("store-locator-page-number", "1");
            //findStores();
        } else {
            $(".tyre-info-group .autocomplete-items").stop().slideToggle(200);
        }
    });

    // Close children when clicking outside
    $(document).on("click", function (e) {
        if (!$(e.target).closest("#rfq-tyres-cont").length) {
            if ($(".tyre-info-group .autocomplete-items").is(":visible")) {
                $(".tyre-info-group .autocomplete-items").stop().slideUp(200);
            }
        }
    });
    $('input[name="rfq_tyre_tag"]').on("change", function () {
        $("#selectedTagCont").html("");
        var selectedTagHTML = "";
        $("input[name^='rfq_tyre_tag']").each(function () {
            if (this.checked) selectedTagHTML += "<li class='rfq-tyre-tag-list-item ' name='" + this.id + "'>" + $(this).next().html() + "</li>";
        });
        $("#selectedTagCont").html(selectedTagHTML);

        var selectedValues = $('input[name="rfq_tyre_tag"]:checked')
            .map(function () {
                return this.dataset.tyreName;
            })
            .get();

        const $tyreList = $(".rfq-form .tyres-list");

        if ($tyreList.length) {
            $tyreList.val(selectedValues.join(", "));
        }

        if (selectedValues.length > 0) {
            $(".rfq-form").removeClass("d-none");
            $(".btn-submit").prop("disabled", false);
        } else {
            $(".rfq-form").addClass("d-none");
            $(".btn-submit").prop("disabled", true);
        }
    });
    ////////// END OF RFQ TYRE DROPDOWN //////////

    const $preselectedTyre = $(".preselected_tyre_model .rfq-tyre-tag-list-item");
    const $tyreList = $(".rfq-form .tyres-list");
    if ($preselectedTyre.length && $tyreList.length) {
        $tyreList.val($preselectedTyre.data("tyreName"));
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const select = document.querySelector("#preselected_tyre_size");

    if (!select) return;
    const instance = new GYSelect(select);
    instance.clear();

    select.addEventListener("gyselect:select", (e) => {
        console.log("Selected:", e.detail.value);
        console.log("Data:", e.detail.data);

        $(".rfq-form").removeClass("d-none");
        $(".btn-submit").prop("disabled", false);
        const value = e.detail.value;
        const $sizeField = $(".rfq-form .size-field");
        $sizeField.val(value);
    });
});
function filterTyres() {
    const params = new URLSearchParams(window.location.search);
    // Get the values
    const tireFinder = params.get("tireFinder") === "true";
    const tireSize = params.get("tireSize");

    $.ajax({
        url: wpApiSettings.root + "goodyearforward/v1/tyres",
        method: "GET",
        data: {
            page_no: page,
            page_size: page_size,
            category: category,
            tire_size: (tireFinder && tireSize && tireSize.replace(/[^0-9\-]/g, "")) || null,
        },
        beforeSend: function (xhr) {
            xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
        },
        success: function (data) {
            console.log(data);
        },
        complete: function () {
            $(".spinner").hide();
        },
    });
}
